import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classnames from 'classnames';
import { accountIcons } from 'images';
import { Button } from 'components/Ui';
import ClearIcon from '@material-ui/icons/Clear';
import { deleteAssociatedBillingAccount as deleteAssociatedBillingAccountRequest } from 'containers/PrimoProfile/actions';

import styles from './styles.scss';

const renderEmail = (billingAccount) => (
  <Fragment>
    <div className={styles.emailContainer}>
      <div className={styles.emailIconContainer}>
        <span className={styles.emailIcon}>
          <img src={accountIcons.Person} alt="" />
        </span>
      </div>
      <div>
        <div className={styles.emailText}>{billingAccount.userName}</div>
      </div>
    </div>
  </Fragment>
);

const renderRemoveEmailText = () => (
  <Fragment>
    <span>Are you sure you want to remove this account login?</span>
  </Fragment>
);

const EmailBlock = ({ billingAccount, deleteAssociatedBillingAccount }) => {
  const [showRemoveConfirmation, changeRemoveConfirmation] = useState(false);

  const handleRemoveEmail = () => {
    changeRemoveConfirmation(false);
    deleteAssociatedBillingAccount(billingAccount);
  };

  const handleShowRemoveConfirmation = () => {
    changeRemoveConfirmation(true);
  };

  const handleCancelRemoveConfirmation = () => {
    changeRemoveConfirmation(false);
  };

  return (
    <div
      className={classnames(
        styles.emailBlock,
        showRemoveConfirmation && styles.focus,
      )}
    >
      <div className={styles.info}>
        {!showRemoveConfirmation
          ? renderEmail(billingAccount)
          : renderRemoveEmailText()}
      </div>
      <div className={styles.buttons}>
        {!showRemoveConfirmation ? (
          <Fragment>
            <Button
              className={styles.clearIcon}
              link
              icon={<ClearIcon />}
              onClick={handleShowRemoveConfirmation}
              type="button"
            />
          </Fragment>
        ) : (
          <Fragment>
            <Button
              link
              onClick={handleRemoveEmail}
              text="Remove"
              type="button"
            />
            <Button
              link
              text="Cancel"
              onClick={handleCancelRemoveConfirmation}
              type="button"
            />
          </Fragment>
        )}
      </div>
    </div>
  );
};

EmailBlock.propTypes = {
  billingAccount: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {
  deleteAssociatedBillingAccount: deleteAssociatedBillingAccountRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailBlock);
